import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import http from '../../../lib/http/index.js';
import { createSelector } from 'reselect';
const fetchTitularidadesData = async () => {
    const contratos = (await http.TABLE('/contratos')).body;
    const titularidadesCdc = (await http.TABLE('/titularidadcontratos-cdc')).body;
    const personas =  (await http.TABLE('/personas')).body;
    const clasesContratos = (await http.TABLE('/clasesContrato')).body;

    return {
        contratos,
        titularidadesCdc,
        clasesContratos,
        personas,
    };
};

// Crear una función selector memoizada utilizando createSelector
export const selectTitularidadesData = createSelector(
    state => state.titularidades.data,
    data => data
);

// Crear una función selector memoizada utilizando createSelector
export const selectTitularidadesFetching = createSelector(
    state => state.titularidades.fetching,
    fetching => fetching
);


export const getTitularidadesData = createAsyncThunk('GET_TITULARIDADES', async (payload, thunkAPI) => {
     // Comprobar si los datos ya están en caché
     const cachedData = selectTitularidadesData(thunkAPI.getState());
     if (cachedData && Object.keys(cachedData).length > 0) {
         return cachedData;
     }
     // Si los datos no están en caché, obtenerlos de la API
     const res = await fetchTitularidadesData();
     return res;
});
const initialState = {
    //pendingRequests: 0,
    fetching: 0,
    error: null,
    message: null,
    data: {}
};

const titularidadessSlice = createSlice({
    name: 'titularidades',
    initialState,
    reducers: {
        cleanError: (state, action) => ({ ...state, error: null }),
        cleanMessage: (state, action) => ({ ...state, message: null }),
    },
    extraReducers: {
        [getTitularidadesData.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1 }),
        [getTitularidadesData.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: action }),
        [getTitularidadesData.fulfilled]: (state, action) => ({ ...state, data: action.payload, fetching: state.fetching - 1 }),
    },
})

export const { cleanError, cleanMessage } = titularidadessSlice.actions
export default titularidadessSlice.reducer;